import React from 'react';
import {FeedSectionArea } from './style';

const FeedSection = ({children}) => {
    return (
        <FeedSectionArea>{children}</FeedSectionArea>
    );
}

export default FeedSection;